import React from "react";
import { Alert, AlertTitle, Button, Grid } from "@mui/material";
import { Accordion, AccordionSummary, Typography, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";

const ErrorPage = ({ error, resetErrorBoundary }) => {
  return (
    <Grid container alignItems="center" direction="column" id={"error-container"} justify="center">
      <Grid item style={{ paddingTop: "16%" }} xs={12}>
        <Alert
          action={
            resetErrorBoundary && (
              <Button
                color="inherit"
                size="large"
                title="Reset"
                onClick={() => resetErrorBoundary()}
              >
                Reset
              </Button>
            )
          }
          severity="error"
        >
          <AlertTitle>Something went wrong</AlertTitle>
          {error?.message && (
            <Accordion>
              <AccordionSummary
                aria-controls="ErrorContent"
                expandIcon={<ExpandMoreIcon />}
                id="Error-header"
              >
                <Typography>Details</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{error?.message}</Typography>
              </AccordionDetails>
            </Accordion>
          )}
          We have already reported the bug. If the error continues, contact{" "}
          <a href="mailto:cazcon@techint.com?subject=Error en Reports"> Support</a>
        </Alert>
      </Grid>
    </Grid>
  );
};

ErrorPage.propTypes = {
  resetErrorBoundary: PropTypes.func.isRequired,
  error: PropTypes.instanceOf(Error),
};

export default ErrorPage;
